// extracted by mini-css-extract-plugin
export default {"span":"button_span__ZWfLC","icon":"button_icon__qafWb","active":"button_active__urbcy"};